 <span [pTooltip]="value" [innerHTML]="valueWithMask"></span>
